import { get } from "../helpers/api_helper"

const CMS_BASE_URL = "/cms"

export const getCitiesService = (params, rejectWithValue) => get(`${CMS_BASE_URL}/cities`, { params }, rejectWithValue)
export const getProvinceService = (params, rejectWithValue) => get(`${CMS_BASE_URL}/province`, { params }, rejectWithValue)
export const getRegionService = (params, rejectWithValue) => get(`${CMS_BASE_URL}/regions`, { params }, rejectWithValue)
